export default {"src":"/_next/static/media/cat-blue.f9589dbf.svg","height":96,"width":97,"blurWidth":0,"blurHeight":0};